import RootComponent from './components/Root.vue';
import VueLazyload from 'vue-lazyload';

require("../../../../../resources/js/gtm.js");

(() => {
	const VUE_ELEMENT_ID = "configurator-app";

	// Vue root element not found on page -> don't continue processing this code
	if (!document.getElementById(VUE_ELEMENT_ID)) return;

	// Load Axios - HTTP request library
	window.axios = require('axios');
	window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

	// Register CSRF Token as a common jQuery header so that all HTTP reuqests automatically have it attached
	let token = document.head.querySelector('meta[name="csrf-token"]');

	if (token)
		window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
	else
		console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

	// Load Vue
	window.Vue = require('vue/dist/vue.common.js');

	// Responsive grid settings
	Vue.prototype.$grid = {
		viewportWidth() {
			return window.innerWidth;
		},

		isMobile(viewport = this.viewportWidth()) {
			return viewport < 768;
		},

		_deviceChangeCallbacks: [],
		_lastViewportWidth: 0,

		// Callback once device changes from mobile to desktop or vice versa
		deviceChange(callback) {
			// Initial call -> set listener
			if (!this._deviceChangeCallbacks.length) {
				this._lastViewportWidth = this.viewportWidth();

				window.addEventListener("resize", () => {
					let isMobile = this.isMobile();

					// State has changed
					if (isMobile !== this.isMobile(this._lastViewportWidth)) {
						// Loop through callbacks
						this._deviceChangeCallbacks.forEach((item) => {
							item(isMobile);
						});
					}

					// Save current viewport width
					this._lastViewportWidth = this.viewportWidth();
				});
			}

			// Add callback
			this._deviceChangeCallbacks.push(callback);
		}
	};

	// Data settings
	const BACKEND_CONFIG_DATA = JSON.parse(CONFIGURATOR_DATA);
	const PROFILE_MEASUREMENTS = DEFAULT_MEASUREMENTS ? JSON.parse(DEFAULT_MEASUREMENTS) : null;

	Vue.prototype.$imageUrl = (filename) => {
		return BACKEND_CONFIG_DATA.baseImgUrl + "/" + filename;
	};

    const TR = JSON.parse(TRANSLATIONS);
    const BASE_URL = BACKEND_CONFIG_DATA.baseUrl;
    const BASE_URL_SLUGLESS = BACKEND_CONFIG_DATA.baseUrlSlugless;

    Vue.prototype.$baseUrl = BASE_URL;
    Vue.prototype.$baseUrlSlugless = BASE_URL_SLUGLESS;
    Vue.prototype.constructUrl = (step, includeSlug = true) => `${includeSlug ? BASE_URL : BASE_URL_SLUGLESS}/${TR.stepUrl}${step+1}`;

	Vue.prototype.$tr = TR;

	// Lazyloading
	Vue.use(VueLazyload, {
		preLoad: 1.3,
		error: Vue.prototype.$imageUrl("no-image.jpg"),
		loading: Vue.prototype.$imageUrl("loader.svg"),
		attempt: 1
	});

	Vue.prototype.$settings = BACKEND_CONFIG_DATA.settings;
    Vue.prototype.$apiRoutes = BACKEND_CONFIG_DATA.api;
	Vue.prototype.$generalData = BACKEND_CONFIG_DATA.general;
	Vue.prototype.$defaultMeasurements = Vue.observable({
        value: PROFILE_MEASUREMENTS
    });

	Vue.prototype.$api = (routeName, data, method = "POST") => {
		return axios({
			url: BACKEND_CONFIG_DATA.api[routeName],
			method: method,
			data: data
		});
	};

	// Data about configuration that should be loaded based on URL slug
	const configurationData = JSON.parse(CONFIGURATION_DATA);

	let defaultProducts = {};
	let defaultMeasurements = {};

	if (configurationData) {
		defaultProducts = configurationData.products;
		defaultMeasurements = configurationData.measurements;
		Vue.set(Vue.prototype.$settings, "originalSlug", configurationData.originalSlug);
        Vue.set(Vue.prototype.$settings, "editBasket", configurationData.editBasket);
	} else if (PROFILE_MEASUREMENTS) {
		defaultMeasurements = {
			cut: PROFILE_MEASUREMENTS.cut,
			height: PROFILE_MEASUREMENTS.height,
			weight: PROFILE_MEASUREMENTS.weight
		};
	}

	// Create a custom reactive DB mechanism
	// All properties must be set here (even if they should be empty) to be reactive
	// Set: 	this.$set(this.$db.products, "index", "value");
	// Remove: 	this.$delete(this.$db.products, "index");
	// Get: 	this.$db.products.index
	Vue.prototype.$db = Vue.observable({
		products: defaultProducts,
		measurements: defaultMeasurements,
		note: null,
		accessoriesInCart: BACKEND_CONFIG_DATA.accessoriesInCart,

		// Get total price of saved products
		totalPrice: function () {
			let price = 0;

			// Sum all prices
			for (let productId in this.products) {
				let product = this.products[productId];

				if (product && typeof product.priceInt === "number")
					price += product.priceInt;
			}

			// Add currency based on backend data
			return BACKEND_CONFIG_DATA.settings.currencyString.replace("X", price);
		}
	});

    // Pass decoded backend data
	Vue.prototype.$backendConfig = BACKEND_CONFIG_DATA;

    const cartConfiguraitons = JSON.parse(CART_CONFIGURATIONS);
    Vue.prototype.$cartConfigurations = Array.isArray(cartConfiguraitons) ? cartConfiguraitons : Object.values(cartConfiguraitons);

	// Attach Vue application instance to the page
	const app = new Vue({
		el: "#" + VUE_ELEMENT_ID,
		render(h) {
			return h(RootComponent)
		}
	});

})();
